import { createCacheWrapper } from '@utils/cache';
import { DAYS_TO_MS, HOURS_TO_MS } from '@utils/constants';
import { fetchComponentDisplayData } from './request.fetch-component-display-data.js';

const cache = createCacheWrapper({
  timeToLiveMs: 1 * HOURS_TO_MS,
  evictAfterMs: 1 * DAYS_TO_MS
});
function getDisplayData(referenceId, options) {
  return cache(!options?.disableCache ? referenceId : undefined, async () => {
    return fetchComponentDisplayData(referenceId);
  }).getStaleWhileRevalidate();
}

export { getDisplayData };
//# sourceMappingURL=request.get-display-data.js.map
